import { Button, ButtonIconPosition, IconAnimationClassName } from '@nextgen-web-framework/all';
import type { ButtonWithLoadingProps } from './types/propTypes';

const ButtonWithLoading = ({ isLoading, title, disabled, ...resProps }: ButtonWithLoadingProps) => (
  <Button
    title={!isLoading ? title : undefined}
    disabled={disabled || isLoading}
    {...(isLoading && {
      iconPosition: ButtonIconPosition.LEFT,
      icon: {
        iconName: 'spinner-third',
        iconAnimationClassName: IconAnimationClassName.SPIN,
      },
    })}
    {...resProps}
  />
);

export default ButtonWithLoading;
